import { EBannerSize } from '@/app/models/banners.model';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SkeletonBannerComponent } from '../skeleton';
import { TabBarComponent } from '../tab-bar/tab-bar.component';
import {
  PreRenderFooterComponent,
  PreRenderHeaderComponent,
  PreRenderHomeComponent,
  PreRenderLeftMenuComponent,
} from './components';
import { PreRenderRightMenuComponent } from './components/pre-render-right-menu/pre-render-right-menu.component';

@Component({
  selector: 'app-pre-render',
  standalone: true,
  imports: [
    TabBarComponent,
    PreRenderHeaderComponent,
    PreRenderLeftMenuComponent,
    SkeletonBannerComponent,
    PreRenderRightMenuComponent,
    PreRenderFooterComponent,
    PreRenderHomeComponent,
  ],
  templateUrl: './pre-render.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreRenderComponent {
  private readonly router = inject(Router);

  selectedIndex: number = 0;
  secondSizeBanner = EBannerSize.MEDIUM_RECTANGLE;

  menuSelected(index: number) {
    this.selectedIndex = index;

    if (index === 0)
      this.router.navigate(['/'], {
        queryParamsHandling: 'preserve',
      });
    else this.router.navigate(['/noticias']);
  }
}
